// extracted by mini-css-extract-plugin
module.exports = {"text":"ButtonWithSpinner_text__B4pfz","spinner":"ButtonWithSpinner_spinner__aKT3V"};